import { SkeletonCard } from '../common';
import { PlayerSlot } from './PlayerSlot';

const SUBSTITUTES_COUNT = 4;

export function SubstitutesBlock() {
  return (
    <SkeletonCard className="px-[22px] pb-[16px]">
      <div className="flex items-center justify-between w-full">
        {Array.from({ length: SUBSTITUTES_COUNT }).map((_, i) => (
          <PlayerSlot key={i} />
        ))}
      </div>
    </SkeletonCard>
  );
}
